/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateFloorplanDto } from '../../models/create-floorplan-dto';
import { FloorplanDto } from '../../models/floorplan-dto';

export interface FloorplanControllerCreate$Params {
  clientWorkspaceId: string;
      body: CreateFloorplanDto
}

export function floorplanControllerCreate(http: HttpClient, rootUrl: string, params: FloorplanControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
  const rb = new RequestBuilder(rootUrl, floorplanControllerCreate.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloorplanDto>;
    })
  );
}

floorplanControllerCreate.PATH = '/api/floorplan/{clientWorkspaceId}';
